// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__YZddB","sidebarDimmed":"Sidebar_sidebarDimmed__F2MtW Sidebar_sidebar__YZddB"};